import { assistedAffiliationClient } from "./assistedAffiliationClient";
import { getAssistedAffiliationHost } from "./getAssistedAffiliationHost";
import {
  ApiEnvelope,
  AssistedAffiliationListParams,
  AssistedAffiliationListResponse,
} from "./types";

const assistedAffiliationListEndpoint = "/v1/assisted-affiliation/all";

/**
 * Consulta paginada de solicitudes. Apunta al mock o al servicio definitivo sin cambiar este archivo.
 * @param params - `pageNumber` empieza en 0, `pageSize` es su tamaño, y los filtros son opcionales.
 * @returns Los items y totales ya desenvueltos; relanza el error para que la pantalla lo traduzca.
 */
export const getAssistedAffiliationListService = async (
  params: AssistedAffiliationListParams,
): Promise<AssistedAffiliationListResponse> => {
  const host = await getAssistedAffiliationHost();

  // El endpoint es POST porque el body lleva la paginación y los filtros. Los filtros ya vienen con
  // los nombres del contrato y solo con las claves que se pidieron, así que viajan tal cual.
  const response = await assistedAffiliationClient.post<
    ApiEnvelope<AssistedAffiliationListResponse>
  >(`${host}${assistedAffiliationListEndpoint}`, params);

  // El envoltorio se abre aquí para que la pantalla solo vea el listado: si otra API lo adopta o lo
  // deja, el cambio no sale de esta capa.
  return response.data.data;
};
